import React from 'react';
import './DisputeInfoModal.css';

interface DisputeInfoModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const DisputeInfoModal: React.FC<DisputeInfoModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="dispute-info-modal-overlay" onClick={onClose}>
      <div className="dispute-info-modal" onClick={(e) => e.stopPropagation()}>
        <div className="dispute-info-modal-header">
          <h2>How to Evaluate Disputes</h2>
          <button className="dispute-info-modal-close" onClick={onClose}>×</button>
        </div>
        
        <div className="dispute-info-modal-content">
          <ol className="dispute-info-steps">
            <li>
              <strong>Watch the video carefully</strong>
              <p>Review the entire video to understand what the AI model was asked to do and what it actually did.</p>
            </li>
            
            <li>
              <strong>Review the dispute details</strong>
              <p>Read the user's dispute note and their proposed score (Success, Failed, or Bad Task). Consider their reasoning carefully.</p>
            </li>
            
            <li>
              <strong>Choose Accept or Reject</strong>
              <ul>
                <li><strong>Accept:</strong> The dispute has merit and you generally agree with the user's assessment</li>
                <li><strong>Reject:</strong> The dispute is incorrect or lacks sufficient justification</li>
              </ul>
            </li>
            
            <li>
              <strong>Set the Final Problem Status</strong>
              <p>Regardless of accepting or rejecting the dispute, you must manually select what the problem's final status should be:</p>
              <ul>
                <li><strong>Success:</strong> The AI successfully completed the task</li>
                <li><strong>Failed:</strong> The AI failed to complete the task correctly</li>
                <li><strong>Bad Task:</strong> The problem itself is flawed, ambiguous, or impossible to complete</li>
              </ul>
            </li>
            
            <li>
              <strong>Provide a reason</strong>
              <p>Write a clear explanation for your decision, especially if your final status differs from what was proposed.</p>
            </li>
          </ol>
          
          <div className="dispute-info-important">
            <strong>Important:</strong> You have full control over the final problem status. Even if you accept a dispute, you can still set a different final status if you believe it's more accurate. A warning will appear if your final status doesn't match the expected outcome based on your accept/reject decision.
          </div>
        </div>
        
        <div className="dispute-info-modal-footer">
          <button className="dispute-info-modal-ok" onClick={onClose}>Got it</button>
        </div>
      </div>
    </div>
  );
};

export default DisputeInfoModal;